import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError, type U2000ApiErrorResult } from '../../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../../u2000Core/context/toast/U2000ToastContext';
import { NS } from '../U3206';
import { doGetTokenUsage, luHandleAppiError, type U3206TokenUsageReport } from '../U3206Service';

export function useU3206TokenUsageHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation(NS);
  const toast = useToast();
  const [report, setReport] = useState<U3206TokenUsageReport | null>(null);
  const [loading, setLoading] = useState(false);

  const loadTokenUsage = useCallback(
    async (groupId: string) => {
      setLoading(true);
      try {
        const response = await doGetTokenUsage(axios, groupId);
        const nextReport = response.data?.result ?? null;
        setReport(nextReport);
        return nextReport;
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError) as U2000ApiErrorResult;
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        setReport(null);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [axios, t, toast],
  );

  const clearTokenUsage = useCallback(() => {
    setReport(null);
  }, []);

  return { report, loading, loadTokenUsage, clearTokenUsage };
}
